$(document).ready(function () {

    
    
    checkeMenu();
    $(window).resize(function(){
        checkeMenu();
    });


    function checkeMenu(){
        var windowWidth = $(window).width();
    
        /* LEVEL 2 */
        $('.desktopnav > li > div > ul.submenu').each(function(){
            var submenuFullwidth = $(this).offset().left + $(this).outerWidth(true);
            if(submenuFullwidth > windowWidth){
                $(this).css('right','10px');
            }
        });

        /* LEVEL 3 */
        $('.desktopnav > li > div > ul.submenu ul.submenu').each(function(){
            var parentwidh = $(this).parent().outerWidth(true);
            var myoffset = $(this).parent().offset().left;
            var submenuFullwidth = parentwidh + myoffset + $(this).outerWidth(true);
            
            if(submenuFullwidth > windowWidth){
                $(this).addClass('overlap');   
                /*
                $(this).find('li').css({'right':'0','left':'auto','width':'200px'});
                $(this).hover().find('li').css({'width':'200px'});
            */
            } else {
                $(this).removeClass('overlap');   
            }
        });
    }
    
   
});